import {HttpModule} from '@angular/http';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {EnsureModuleLoadedOnceGuard} from '../modules/ensure.module.loaded.once.guard';
import {
    BusinessActivityDurationsService,
    BusinessProfileService,
    CountriesService,
    CurrenciesService,
    EmployeesNumbersService,
    KeyFinancialIndicatorsService,
    ProductsService,
    PurposesService,
    SepaErrorService,
    SourcesService,
    TotalBalancesService
} from './dictionaries'
import {RecallPaymentReasonService} from "./dictionaries/recall-payment-reason.service";

@NgModule({
    imports: [HttpModule],
    providers: [
        BusinessActivityDurationsService,
        BusinessProfileService,
        CountriesService,
        CurrenciesService,
        EmployeesNumbersService,
        KeyFinancialIndicatorsService,
        ProductsService,
        SourcesService,
        TotalBalancesService,
        PurposesService,
        SepaErrorService,
        RecallPaymentReasonService
    ]
})
export class DictionaryModule extends EnsureModuleLoadedOnceGuard {

    //Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
    constructor(@Optional() @SkipSelf() parent: DictionaryModule) {
        super(parent);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionary.module.ts